import React from "react";

import Modal from "../Modals/Modal";

const MESSAGES = {
  slots: "슬롯 롤링 조건이 충족되지 않았습니다.",
  live: "라이브 롤링 조건이 충족되지 않았습니다.",
  sport: "스포츠 롤링 조건이 충족되지 않았습니다.",
  minigames: "미니게임 롤링 조건이 충족되지 않았습니다.",
  two_types: "보너스 롤링 조건이 충족되지 않았습니다.",
};

const BonusRecoveryModal = ({
  show,
  onHide,
  onConfirm,
  onCancel,
  bonusgames,
  actionType = "RECOVER",
}) => {
  const blocked = actionType === "BLOCK";
  const lead = MESSAGES[String(bonusgames || "").toLowerCase()] || MESSAGES.two_types;
  const message = blocked
    ? "보너스 롤링 조건이 충족되지 않아 현재 게임은 이용할 수 없습니다. 롤링 조건 충족 후 다시 이용해 주세요."
    : `${lead} 계속 진행하면 보너스 금액이 회수됩니다. 진행하시겠습니까?`;

  return (
    <Modal isOpen={Boolean(show)} onClose={onHide} maxWidth={420} zIndex={9000}>
      <div className="crypto-sports-bonus-modal">
        <h2>{blocked ? "이용 제한" : "보너스 회수 안내"}</h2>
        <p>{message}</p>
        <div className="crypto-sports-bonus-actions">
          {!blocked ? (
            <button type="button" onClick={onCancel || onHide}>취소</button>
          ) : null}
          <button
            type="button"
            className="is-primary"
            onClick={() => {
              if (!blocked) onConfirm?.();
              onHide?.();
            }}
          >
            {blocked ? "닫기" : "확인"}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default BonusRecoveryModal;
